import { useEffect } from 'react';

const Cognito = () => {
  useEffect(
    () =>
      window.location.replace(
        `${process.env.REACT_APP_COGNITO_URI}/login` +
          `?client_id=${process.env.REACT_APP_COGNITO_CLIENT_ID}&response_type=code&scope=aws.cognito.signin.user.admin` +
          '&redirect_uri=' +
          process.env.REACT_APP_REDIRECT_URI
      ),
    []
  );
  return <div>Redirecting...</div>;
};

export default Cognito;
